import React from 'react';
import {
  BrowserRouter as Router, Switch, Route, Redirect,
} from 'react-router-dom';

import Layout from '../layout/layout';

import appConfig from '../config/app-config';

import dashboardRoutes from './dashboard-route';

const allRoutes = [
  ...dashboardRoutes,
];

/**
 * 获取所有路由
 * @returns {*[]}
 */
function getAllRouter(config) {
  return config
    .map((route) => {
      if (route.children) {
        return getAllRouter(route.children);
      }
      return (
        <Route
          key={route.key}
          path={route.path}
          component={route.component}
          exact={!!route.exact}
        />
      );
    });
}

function Routes() {
  return (
    <Router basename={appConfig.basePath}>
      <Layout>
        <Switch>
          {getAllRouter(allRoutes)}
          <Redirect path="*" to="/productDetail" />
        </Switch>
      </Layout>
    </Router>
  );
}

export default Routes;
